<form [formGroup]="formServiciosBucket" class="bucket-form">

  <!-- ==========================================================================
         01. ENCABEZADO
         ========================================================================== -->

  <div class="bucket-form-header">

    <div class="bucket-header-icon">
      <i class="fa-solid fa-cloud"></i>
    </div>

    <div class="bucket-header-content">

      <span class="bucket-eyebrow">
        ALMACENAMIENTO
      </span>

      <h4>
        Configuración del bucket
      </h4>

      <p>
        Configura el proveedor, ubicación y credenciales utilizadas
        para el almacenamiento de archivos.
      </p>

    </div>

  </div>


  <!-- ==========================================================================
         02. INFORMACIÓN DEL ALMACENAMIENTO
         ========================================================================== -->

  <div class="bucket-section">

    <div class="bucket-section-header">

      <div class="bucket-section-icon">
        <i class="fa-solid fa-database"></i>
      </div>

      <div>
        <h5>Información del almacenamiento</h5>

        <p>
          Define dónde serán almacenados los documentos.
        </p>
      </div>

    </div>


    <div class="row g-3">

      <!-- ==================================================================
                 PROVEEDOR
                 ================================================================== -->

      <div class="col-lg-6 col-md-6 col-12">

        <div class="bucket-field">

          <label class="form-label">
            Proveedor
            <span class="required">*</span>
          </label>

          <div class="bucket-input">

            <span class="bucket-input-icon">
              <i class="fa-solid fa-cloud"></i>
            </span>

            <input type="text" class="form-control" placeholder="Ej: AWS" formControlName="proveedor">

          </div>


          <span class="bucket-error" *ngIf="
                            formServiciosBucket.get('proveedor')?.touched &&
                            formServiciosBucket.get('proveedor')?.errors?.['required']
                        ">

            <i class="fa-solid fa-circle-exclamation"></i>

            El proveedor es requerido.

          </span>

        </div>

      </div>


      <!-- ==================================================================
                 REGIÓN
                 ================================================================== -->

      <div class="col-lg-6 col-md-6 col-12">

        <div class="bucket-field">

          <label class="form-label">
            Región
            <span class="required">*</span>
          </label>

          <div class="bucket-input">

            <span class="bucket-input-icon">
              <i class="fa-solid fa-location-dot"></i>
            </span>

            <input type="text" class="form-control" placeholder="Ej: us-east-1" formControlName="region">

            <span class="bucket-lock" *ngIf="isEditMode">

              <i class="fa-solid fa-lock"></i>

            </span>

          </div>


          <span class="bucket-field-help" *ngIf="isEditMode">

            La región no puede modificarse.

          </span>


          <span class="bucket-error" *ngIf="
                            formServiciosBucket.get('region')?.touched &&
                            formServiciosBucket.get('region')?.errors?.['required']
                        ">

            <i class="fa-solid fa-circle-exclamation"></i>

            La región es requerida.

          </span>

        </div>

      </div>


      <!-- ==================================================================
                 BUCKET / CONTENEDOR
                 ================================================================== -->

      <div class="col-lg-6 col-md-6 col-12">

        <div class="bucket-field">

          <label class="form-label">
            Bucket / Contenedor
            <span class="required">*</span>
          </label>

          <div class="bucket-input">

            <span class="bucket-input-icon">
              <i class="fa-solid fa-box-archive"></i>
            </span>

            <input type="text" class="form-control" placeholder="Ej: jobsite-documentos"
              formControlName="bucketOContenedor">

            <span class="bucket-lock" *ngIf="isEditMode">

              <i class="fa-solid fa-lock"></i>

            </span>

          </div>


          <span class="bucket-field-help" *ngIf="isEditMode">

            El contenedor no puede modificarse.

          </span>


          <span class="bucket-error" *ngIf="
                            formServiciosBucket.get('bucketOContenedor')?.touched &&
                            formServiciosBucket.get('bucketOContenedor')?.errors?.['required']
                        ">

            <i class="fa-solid fa-circle-exclamation"></i>

            El bucket o contenedor es requerido.

          </span>

        </div>

      </div>


      <!-- ==================================================================
                 PREDETERMINADO
                 ================================================================== -->

      <div class="col-lg-6 col-md-6 col-12">

        <div class="default-bucket-option">

          <div class="default-bucket-content">

            <div class="default-bucket-icon">

              <i class="fa-solid fa-star"></i>

            </div>


            <div class="default-bucket-text">

              <strong>
                Bucket predeterminado
              </strong>

              <span>
                Utilizar como almacenamiento principal
                del servicio.
              </span>

            </div>

          </div>


          <label class="bucket-switch mb-0">

            <input id="es_predeterminado" type="checkbox" formControlName="es_predeterminado"
              [disabled]="BucketDefault">

            <span class="bucket-switch-slider"></span>

          </label>

        </div>


        <span class="bucket-field-help default-help" *ngIf="BucketDefault">

          <i class="fa-solid fa-circle-info"></i>

          Este bucket ya está configurado como predeterminado.

        </span>

      </div>

    </div>

  </div>


  <!-- ==========================================================================
         03. CREDENCIALES
         ========================================================================== -->

  <div class="bucket-section credentials-section">

    <div class="bucket-section-header">

      <div class="bucket-section-icon credentials">
        <i class="fa-solid fa-key"></i>
      </div>

      <div>

        <h5>
          Credenciales de acceso
        </h5>

        <p>
          Configura las credenciales JSON necesarias para acceder
          al proveedor de almacenamiento.
        </p>

      </div>

    </div>


    <!-- ==========================================================================
             04. JSON EDITOR
             ========================================================================== -->

    <div class="json-editor-container">


      <!-- HEADER -->

      <div class="json-editor-header">

        <div class="json-editor-header-left">

          <span class="editor-dot red"></span>
          <span class="editor-dot yellow"></span>
          <span class="editor-dot green"></span>


          <div class="json-editor-title">

            <i class="fa-solid fa-code"></i>

            <span>
              credentials.json
            </span>

          </div>

        </div>


        <div class="json-editor-actions">

          <button type="button" class="json-action-button" (click)="formatJson()" title="Formatear JSON">

            <i class="fa-solid fa-align-left"></i>

            <span>
              Formatear
            </span>

          </button>


          <button type="button" class="json-action-button" (click)="copyJson()" title="Copiar JSON">

            <i class="fa-regular fa-copy"></i>

            <span>
              Copiar
            </span>

          </button>

        </div>

      </div>


      <!-- EDITOR -->

      <div class="json-editor-body">

        <textarea class="json-editor-textarea" rows="12" placeholder='{
  "accessKeyId": "XXXXXXXX",
  "secretAccessKey": "XXXXXXXX"
}' formControlName="credencialesJson" (paste)="formatJsonOnPaste()" (blur)="formatJson()">
                </textarea>

      </div>


      <!-- FOOTER / ESTADO -->

      <div class="json-editor-footer" [class.valid]="jsonValido" [class.invalid]="!jsonValido">

        <div class="json-status">

          <ng-container *ngIf="jsonValido">

            <i class="fa-solid fa-circle-check"></i>

            <span>
              JSON válido
            </span>

          </ng-container>


          <ng-container *ngIf="!jsonValido">

            <i class="fa-solid fa-circle-exclamation"></i>

            <span>
              JSON inválido
            </span>

          </ng-container>

        </div>


        <div class="json-language">
          JSON
        </div>

      </div>

    </div>


    <!-- ERROR CREDENCIALES -->

    <span class="bucket-error" *ngIf="
                formServiciosBucket.get('credencialesJson')?.touched &&
                formServiciosBucket.get('credencialesJson')?.errors?.['required']
            ">

      <i class="fa-solid fa-circle-exclamation"></i>

      Las credenciales JSON son requeridas.

    </span>


    <!-- INFORMACIÓN -->

    <div class="credentials-help">

      <i class="fa-solid fa-shield-halved"></i>

      <span>
        Verifica que las credenciales correspondan al proveedor
        configurado antes de guardar.
      </span>

    </div>

  </div>


  <!-- ==========================================================================
         05. ACCIONES
         ========================================================================== -->

  <div class="bucket-form-actions">

    <div class="bucket-action-info">

      <i class="fa-solid fa-circle-info"></i>

      <span>
        Los campos marcados con * son obligatorios.
      </span>

    </div>


    <div class="bucket-action-buttons">

      <button type="button" class="bucket-btn-close" (click)="CloseModal()">

        Cerrar

      </button>


      <button type="button" class="bucket-btn-save" (click)="guardarServicioBucket()" [disabled]="
                    formServiciosBucketIsSubmited ||
                    formServiciosBucket.invalid ||
                    !jsonValido
                ">

        <span class="spinner-border spinner-border-sm" *ngIf="formServiciosBucketIsSubmited">
        </span>

        <i class="fa-solid fa-floppy-disk" *ngIf="!formServiciosBucketIsSubmited">
        </i>

        <span>
          Guardar
        </span>

      </button>

    </div>

  </div>

</form>